import { gql } from "@apollo/client";

export const LOGIN_MUTATION = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation resetPassword($email: String!) {
    resetPassword(email: $email) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const VERIFY_RECOVERY_CODE_MUTATION = gql`
  mutation verifyRecoveryCode($code: Int!, $email: String!) {
    verifyRecoveryCode(code: $code, email: $email) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const CREATE_NEW_PASSWORD_MUTATION = gql`
  mutation createNewPassword(
    $email: String!
    $newPassword1: String!
    $newPassword2: String!
  ) {
    createNewPassword(
      email: $email
      newPassword1: $newPassword1
      newPassword2: $newPassword2
    ) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const CREATE_MAILBOX_MUTATION = gql`
  mutation createMailbox(
    $host: String!
    $port: Int!
    $email: String!
    $password: String!
  ) {
    createMailbox(
      host: $host
      port: $port
      email: $email
      password: $password
    ) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const UPDATE_MAILBOX_MUTATION = gql`
  mutation updateMailbox(
    $host: String!
    $port: Int!
    $email: String!
    $password: String!
  ) {
    updateMailbox(
      host: $host
      port: $port
      email: $email
      password: $password
    ) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const DELETE_MAILBOX_MUTATION = gql`
  mutation deleteMailbox($mailboxId: ID!) {
    deleteMailbox(mailboxId: $mailboxId) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const START_MAILBOX_SESSION = gql`
  mutation startMailboxSession($mailboxId: ID!) {
    startMailboxSession(mailboxId: $mailboxId) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const STOP_MAILBOX_SESSION = gql`
  mutation stopMailboxSession($mailboxId: ID!) {
    stopMailboxSession(mailboxId: $mailboxId) {
      ... on SuccessType {
        __typename
        message
      }
      ... on NotifyType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const START_ALL_MAILBOX_SESSIONS = gql`
  mutation startAllMailboxSessions {
    startAllMailboxSessions {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const STOP_ALL_MAILBOX_SESSIONS = gql`
  mutation stopAllMailboxSessions {
    stopAllMailboxSessions {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const LOG_CLIENT_ERROR = gql`
  mutation logClientError(
    $stack: String!
    $source: String!
    $message: String!
  ) {
    logClientError(message: $message, source: $source, stack: $stack) {
      ok
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation changePassword(
    $oldPassword: String!
    $newPassword2: String!
    $newPassword1: String!
  ) {
    changePassword(
      newPassword1: $newPassword1
      newPassword2: $newPassword2
      oldPassword: $oldPassword
    ) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const CREATE_APPLICATION_FILE = gql`
  mutation createApplicationFile(
    $id: ID!
    $fileId: ID
    $isSelectApplicationForm: Boolean!
  ) {
    createApplicationFile(
      id: $id
      fileId: $fileId
      isSelectApplicationForm: $isSelectApplicationForm
    ) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const CHANGE_FAILED_EMAIL_STATUS_TO_REVIEW = gql`
  mutation changeFailedEmailStatusToReview($emailId: ID!) {
    changeFailedEmailStatusToReview(emailId: $emailId) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const RESOLVE_MANUAL = gql`
  mutation resolveManual($input: EmailAIExtractedDataInputType!) {
    resolveManual(input: $input) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const MERGE_BANK_STATEMENTS = gql`
  mutation mergeBankStatements(
    $id: ID!
    $files: [ID!]!
    $isSelectBankStatement: Boolean!
    $filename: String!
  ) {
    mergeBankStatements(
      id: $id
      files: $files
      isSelectBankStatement: $isSelectBankStatement
      filename: $filename
    ) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const MERGE_BANK_STATEMENT_GROUPS = gql`
  mutation mergeBankStatementGroups(
    $id: ID!
    $groups: [BankStatementGroupInput!]!
    $isSelectBankStatement: Boolean!
  ) {
    mergeBankStatementGroups(
      id: $id
      groups: $groups
      isSelectBankStatement: $isSelectBankStatement
    ) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const FILL_ENTITY_ID = gql`
  mutation fillEntityId(
    $id: ID!
    $entityId: String!
    $isFindEntityId: Boolean!
    $entityStatus: Int
  ) {
    fillEntityId(
      id: $id
      entityId: $entityId
      isFindEntityId: $isFindEntityId
      entityStatus: $entityStatus
    ) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;

export const SELECT_AGENT = gql`
  mutation selectAgent($agentId: String, $id: ID!, $isSelectAgent: Boolean!) {
    selectAgent(agentId: $agentId, id: $id, isSelectAgent: $isSelectAgent) {
      ... on SuccessType {
        __typename
        message
      }
      ... on ErrorType {
        __typename
        message
      }
    }
  }
`;
